<script>
    import DateTime from 'luxon/src/datetime.js'

  export default{
      getMonthStart(){
          var dt = DateTime.local();
          var ret = DateTime.local(dt.year, dt.month, 1, 0, 0);
          return ret.toString();
      },
      getToday(){
          var dt =  DateTime.local();
          var ret = DateTime.local(dt.year, dt.month, dt.day, 0, 0);
          return ret.toString();
      },
      getNextDay(){
          var dt =  DateTime.local().plus({ days: 1 });
          var ret = DateTime.local(dt.year, dt.month, dt.day, 0, 0);
          return ret.toString();
      },
      compareFromTo(from, to){
          return DateTime.fromISO(from, {zone: 'utc'}) > DateTime.fromISO(to, {zone: 'utc'});
      },
      compareDifference(from, to, days){
          return DateTime.fromISO(from, {zone: 'utc'}).plus({ days: days }) < DateTime.fromISO(to, {zone: 'utc'});
      },
      getFormattedDDMMYYYY(date, separator = '/')
      {
          return (("0" + date.getDate()).slice(-2) + separator + ("0"+(date.getMonth()+1)).slice(-2) + separator + date.getFullYear());
      },
      getFormattedYYYYMMDD(date, separator = '-')
      {
          return (date.getFullYear()) + separator + ("0"+(date.getMonth()+1)).slice(-2) + separator + (("0" + date.getDate()).slice(-2));
      }
  }
</script>